import {cn} from "@/lib/utils";

export default function GuestHeader({header, subheader, className}) {
    return (
        <>
            <div className={cn('grid gap-3', className)}>
                <h1 className={`font-semibold text-2xl`}>
                    {header}
                </h1>
                {subheader && subheader}
            </div>
        </>
    );
}